<template>
  <div class="riclothes-item-card" :class="{dark: this.$root.config.isDarkTheme}">
    <router-link :to="`product/${productItem.id}`"><RiClothesImage radius="4px" style="width: 100%;" :src="`/products/${productItem.id}/images/cover.webp`"/></router-link>

    <div class="riclothes-item-card--item-container">
      <router-link :to="`product/${productItem.id}`" style="text-decoration: none;"><RiClothesText class="riclothes-item-card--item-name">{{ productItem.name }}</RiClothesText></router-link>

      <RiClothesText class="riclothes-item-card--tag-chip" textSize="0.75rem" style="display: inline-block;" v-for="tag in productItem.tags" :key="tag">{{ tag }}</RiClothesText>
      
      <RiClothesText textSize="1.2rem" class="riclothes-item-card--price-text" style="visibility: hidden; position: static; margin-top: 6px;">{{ productItem.price }}</RiClothesText>
      <RiClothesText textSize="1.2rem" class="riclothes-item-card--price-text">{{ productItem.price }}</RiClothesText>
    </div>
  </div>
</template>

<script>
import RiClothesText from "@/components/RiClothesText.vue";
import RiClothesImage from "../components/RiClothesImage";

export default {
  name: "ri-clothes-item-card",
  components: {
    RiClothesText,
    RiClothesImage
  },
  props: {
    productItem: Object
  }
}
</script>

<style lang="scss" scoped>
.riclothes-item-card {
  --card-background-color: #ffffff;
  --card-shadow-color: rgba(0,0,0,0.14);

  display: inline-block;
  position:relative;
  width: 15%;
  margin: 8px;
  border-radius: 4px;
  background-color: var(--card-background-color);
  transition: 0.5s;
  box-shadow: 0 2px 8px var(--card-shadow-color);
  overflow: hidden;

  &:hover {
    --card-hover-shadow-color: rgb(221, 221, 221);

    box-shadow: 0 8px 8px var(--card-hover-shadow-color);
  }

  &--item-container {
    width: 100%;
    text-align: left;
  }

  &--item-name {
    font-size: 1rem !important;
    font-weight: bold;
    margin-bottom: 4px;
    margin-left: 8px;
    margin-right: 8px;
  }

  &--tag-chip {
    --tag-chip-background-color: #e0e0e0;

    display: inline-block;
    margin-left: 6px;
    padding-left: 4px;
    padding-right: 6px;
    padding-top: 6px;
    padding-bottom: 6px;
    border-radius: 4px;
    background-color: var(--tag-chip-background-color);
    transition: 0.5s;
  }

  &--price-text {
    color: var(--color-blue);
    display: block;
    position: absolute;
    bottom: 4px;
    right: 10px;
    text-align: right;
  }
}

.dark {
  --card-background-color: #2a2a2a;
  --card-shadow-color: rgba(0,0,0,0.20);
  --tag-chip-background-color: #3d3d3d;
  --tag-chip-icon-color: #b6b6b6;

  &:hover {
    --card-hover-shadow-color: rgba(255, 255, 255, 0.2);
  }
}

@media screen and (max-width: 1400px) {
  .riclothes-item-card {
    width: 18%;

    &--item-name {
      font-size: 0.9rem !important;
    }
  }
}

@media screen and (max-width: 1200px) {
  .riclothes-item-card {
    width: 20%;

    &--item-name {
      font-size: 0.85rem !important;
    }
  }
}

@media screen and (max-width: 1000px) {
  .riclothes-item-card {
    width: 24%;
  }
}

@media screen and (max-width: 896px) {
  .riclothes-item-card {
    width: 30%;
  }
}

@media screen and (max-width: 700px) {
  .riclothes-item-card {
    width: 35%;
  }
}

@media screen and (max-width: 600px) {
  .riclothes-item-card {
    width: 42%;

    &--item-name {
      font-size: 0.85rem !important;
    }
  }
}

@media screen and (max-width: 350px) {
  .riclothes-item-card {
    width: 80%;

    &--item-name {
      font-size: 1rem !important;
    }
  }
}
</style>